var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1932 3.96975C10.263 3.90002 10.3458 3.84471 10.4369 3.80697C10.528 3.76923 10.6256 3.74981 10.7242 3.74981C10.8229 3.74981 10.9205 3.76923 11.0116 3.80697C11.1027 3.84471 11.1855 3.90002 11.2552 3.96975C11.325 4.03949 11.3803 4.12227 11.418 4.21338C11.4558 4.30449 11.4752 4.40214 11.4752 4.50075C11.4752 4.59937 11.4558 4.69702 11.418 4.78813C11.3803 4.87924 11.325 4.96202 11.2552 5.03175L6.53024 9.75675C6.38959 9.89736 6.19886 9.97635 5.99999 9.97635C5.80112 9.97635 5.61039 9.89736 5.46974 9.75675L0.74474 5.03175C0.60391 4.89083 0.524832 4.69972 0.524902 4.50049C0.524973 4.30126 0.604186 4.11021 0.745115 3.96938C0.886044 3.82855 1.07715 3.74947 1.27638 3.74954C1.47561 3.74961 1.66666 3.82883 1.80749 3.96975L5.99999 8.163L10.1932 3.96975Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.1b5163027712a982f382d42921017eba.svg";
export { ForwardRef as ReactComponent };